$(document).ready(function(){  
  $( '.js-filter' ).on( 'click', function() {  
    var $color = $(this).attr('data-tab');  
    if ( $color == 'all' ) {
      $( '.js-filterable' ).removeClass( 'is-hidden' );    
    } else {
      $( '.js-filterable' ).addClass( 'is-hidden' );
      $( '.js-filterable[data-tab=' + $color + ']' ).removeClass( 'is-hidden' );
    }
    // Add class "current" to the matching .faq-heading div
    $('.faq-heading[data-tab]').removeClass('current'); // Remove the class from all .faq-heading divs first
    $('.faq-heading[data-tab="' + $color + '"]').addClass('current'); // Add the class to the matching .faq-heading div    
  });

$('.faq-body h6').click(function(e) {
 e.preventDefault();
 let $this = $(this);
 if ($this.next().hasClass('show')) {
   $this.next().slideUp(350);
   $this.next().removeClass('show');
   $this.removeClass('active-accordian');
   $this.parent().removeClass('active-accordian-parent');
 } else {
   $this.parent().parent().find('.faq-inner-body').removeClass('show');
   $('.faq-body h6').removeClass('active-accordian');
   $('.faq-body h6').parent().removeClass('active-accordian-parent');
   $this.parent().parent().find('.faq-inner-body').slideUp(350);
   $this.next().toggleClass('show');
   $this.next().slideToggle(350);
   $this.toggleClass('active-accordian');
   $this.parent().toggleClass('active-accordian-parent');
 }
});


});
  